import { render, staticRenderFns } from "./MakePremiumModal.vue?vue&type=template&id=297e81e3&scoped=true"
import script from "./MakePremiumModal.vue?vue&type=script&lang=js"
export * from "./MakePremiumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e81e3",
  null
  
)

export default component.exports